import { render, staticRenderFns } from "./DropdownComment.vue?vue&type=template&id=6815faf6&scoped=true"
import script from "./DropdownComment.vue?vue&type=script&lang=js"
export * from "./DropdownComment.vue?vue&type=script&lang=js"
import style0 from "./DropdownComment.vue?vue&type=style&index=0&id=6815faf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815faf6",
  null
  
)

export default component.exports